import { useState, useEffect } from "react";
import apiUtils, { ApiResponse } from "../apiUtils";

export interface IapUser {
  id: string;
  email: string;
  name: string;
}

interface AuthMeResponse extends ApiResponse {
  id?: string;
  email?: string;
  name?: string;
}

export function useIapUser() {
  const [user, setUser] = useState<IapUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchUser() {
      if (typeof window !== "undefined" && window.location?.search) {
        const searchParams = new URLSearchParams(window.location.search);
        const errParam = searchParams.get("error");
        if (errParam === "unauthorized_domain") {
          setError(
            "Access denied: only @blackbirdhealth.com accounts are permitted",
          );
          setLoading(false);
          return;
        }
      }

      try {
        const response = await apiUtils.fetchData<AuthMeResponse>(
          "/api/auth/me",
          "GET",
          undefined,
          { skipLogoutOn401: true },
        );
        if ("error" in response) {
          if (response.status === 401) {
            setUser(null);
            setError(null);
          } else {
            setError(response.error ?? null);
          }
        } else {
          setUser({
            id: response.id || "",
            email: response.email || "",
            name: response.name || "",
          });
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err));
      } finally {
        setLoading(false);
      }
    }
    fetchUser();
  }, []);

  return { user, loading, error };
}
